import { render, staticRenderFns } from "./DisplayOrderDetail.vue?vue&type=template&id=ce520562&"
import script from "./DisplayOrderDetail.vue?vue&type=script&lang=js&"
export * from "./DisplayOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./DisplayOrderDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports